<div class="card mb-4">
    <div class="card-body">
        <div class="row">
            <div class="d-flex justify-content-between flex-row flex-wrap gap-3">
                <div class="d-flex">
                    <div class="card-title mb-0">
                        <h4>Organization Details</h4>
                    </div>
                </div>
            </div>
            <div class="card-body ps-4" [class.placeholder-glow]="isLoading()">
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Organization Name</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-6"></span>
                        } @else {
                        <span class="fs-6">{{organization()?.name}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3" *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Update], userPermissionOnly: true }">
                    <label class="col-lg-4 fw-semibold text-muted">Slug</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-4"></span>
                        } @else {
                        <span class="fs-6">{{organizationSettings()?.slug}}</span>
                        }
                    </div>
                </div>
                <ng-container *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Read], organizationId: organization()?.organizationId }">
                    <div class="row mb-3">
                        <label class="col-lg-4 fw-semibold text-muted">Reply-To Email</label>
                        <div class="col-lg-8">
                            @if (isLoading()) {
                            <span class="placeholder col-7"></span>
                            } @else {
                            <span class="fs-6 text-gray-800 text-hover-primary">{{organizationSettings()?.replyToEmailAddress ||
                                ''}}</span>
                            }
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-lg-4 fw-semibold text-muted">Status</label>
                        <div class="col-lg-8">
                            <ms-status-badge [status]="organization()?.status" [isLoading]="isLoading()"></ms-status-badge>
                        </div>
                    </div>
                </ng-container>
                <div class="row mb-3" *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Update], userPermissionOnly: true }">
                    <label class="col-lg-4 fw-semibold text-muted">Pricing Tier</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-4"></span>
                        } @else {
                            <span class="badge bg-info-subtle text-info-emphasis">{{organizationSettings()?.pricingTier | formatLabel}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3" *ifHasPermission="{ requiredPermissions: [OrganizationPermission.Update], userPermissionOnly: false }">
                    <label class="col-lg-4 fw-semibold text-muted">Billing Status</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-4"></span>
                        } @else {
                        <span class="fs-6">{{organizationSettings()?.billingStatus}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Member Count</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-2"></span>
                        } @else {
                        <span class="fs-6">{{organization()?.memberCount || 0 | number}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Time Zone</label>
                    <div class="col-lg-8">
                        @if (isLoading() || isTimezoneLoading()) {
                        <span class="placeholder col-3"></span>
                        } @else {
                        <span class="fs-6">{{timezoneDisplayName()}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Currency</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-4"></span>
                        } @else {
                        <span class="fs-6">{{organizationSettings()?.currency?.name | titlecase}}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>